import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  IActivo,
  ICodigoDispositivoEntrada,
  ICreateComando,
} from 'modelos/src';

import { AuxiliaresModule } from '../../../../../auxiliares/auxiliares.module';
import { ComandosService } from '../../../../../auxiliares/servicios/http/comandos.service';
import { DialogService } from '../../../../../auxiliares/dialog/dialog.service';
import { HelperService } from '../../../../../auxiliares/servicios/helper.service';

interface IEnviarComandoData {
  activo: IActivo;
}

@Component({
  selector: 'app-enviar-comando',
  templateUrl: './enviar-comando.component.html',
  styleUrls: ['./enviar-comando.component.scss'],
  standalone: true,
  imports: [AuxiliaresModule],
})
export class EnviarComandoComponent {
  data = inject<IEnviarComandoData>(MAT_DIALOG_DATA);
  private dialogRef =
    inject<MatDialogRef<EnviarComandoComponent>>(MatDialogRef);
  private service = inject(ComandosService);
  private dialogService = inject(DialogService);
  private helper = inject(HelperService);

  public form: FormGroup;
  public codigosEntrada: ICodigoDispositivoEntrada[] = [];
  public loading = false;
  public selectedTabIndex = 0; // 0 = Cargados, 1 = Personalizado

  // Getter para validar el formulario según el tab activo
  get isFormValid(): boolean {
    if (this.selectedTabIndex === 0) {
      return !!this.form.value.codigo;
    } else {
      return !!this.form.value.codigoPersonalizado?.trim();
    }
  }

  constructor() {
    this.codigosEntrada =
      this.data.activo.tracker?.modelo?.codigos?.codigosEntrada || [];
    this.createForm();
  }

  private createForm() {
    this.form = new FormGroup({
      codigo: new FormControl(null),
      codigoPersonalizado: new FormControl(''),
    });
  }

  public onTabChange(index: number) {
    this.selectedTabIndex = index;
    // Limpiar el formulario al cambiar de tab
    this.form.reset();
  }

  private getData() {
    const payload =
      this.selectedTabIndex === 0
        ? this.form.value.codigo
        : this.form.value.codigoPersonalizado;

    const data: ICreateComando = {
      payload: payload,
      idTracker: this.data.activo.tracker._id,
      estado: 'En Cola',
    };
    return data;
  }

  public async onSubmit() {
    if (this.form.invalid) return;

    // Validar según el tab seleccionado
    if (this.selectedTabIndex === 0 && !this.form.value.codigo) {
      this.helper.notifError('Seleccioná un comando');
      return;
    }
    if (this.selectedTabIndex === 1 && !this.form.value.codigoPersonalizado) {
      this.helper.notifError('Ingresá un código personalizado');
      return;
    }

    this.loading = true;
    const data = this.getData();
    const confirm = await this.dialogService.confirm(
      'Confirmá la acción',
      `¿Confirmás el envío del comando?`,
    );
    if (!confirm) {
      this.loading = false;
      return;
    }
    try {
      // TODO: Implementar el envío del comando
      await this.service.create(data);
      this.helper.notifSuccess('Enviado correctamente');
      this.dialogRef.close(true);
    } catch (error) {
      console.error(error);
      this.helper.notifSuccess('Error al enviar el comando');
    }
    this.loading = false;
  }

  public onClose() {
    this.dialogRef.close();
  }
}
